<template>
  <div class="pa-5 pt-2">
    <v-row justify="right" align="center">
      <v-col cols="12" md="12" lg="12" sm="12" align="center" justify="center">
        <v-autocomplete
          filled
          :items="campaignList"
          label="Campaign"
          item-value="id"
          hide-details
          item-text="name"
          v-model="campaignID"
          @change="changeCampaign"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <div>
      <SummaryBoxes :refresh="isRefresh" :campaignID="campaignID"></SummaryBoxes>
    </div>
    <v-row v-show="campaignID">
      <v-col cols="12">
        <timeline-data-table :refresh="isRefresh" :campaignID="campaignID" :selectedCampaign="selectedCampaign" @updated="invokeTimelineUpdated" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import TimelineDataTable from './DataTable'
import SummaryBoxes from './SummaryBoxes'
import config from '@/config'
export default {
  name: 'campaign-timeline',
  components: {
    TimelineDataTable,
    SummaryBoxes
  },
  data() {
    return {
      campaignList: [],
      campaignID: '',
      selectedCampaign: null,
      isRefresh: 1
    }
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns
    })
  },
  async mounted() {
    await this.getTimelineCampaigns()
    if (this.$route.query.campaignID) {
      this.campaignID = this.$route.query.campaignID
      this.changeCampaign()
    }
  },
  methods: {
    async getTimelineCampaigns() {
      const statuses = [
        config.campaignStatus.DRAFT,
        config.campaignStatus.PENDING_CLIENT_APPROVAL,
        config.campaignStatus.PAIRING_INFLUENCER,
        config.campaignStatus.ONGOING,
        config.campaignStatus.COMPLETE
      ]
      await this.$store.dispatch('campaign/paginateCampaigns', {
        filters: {
          per_page: 999,
          status: statuses.join(','),
          sort: 'updatedAt DESC'
        }
      })
      this.campaignList = this.campaigns.map(element => {
        return {
          name: element.name,
          id: element.id
        };
      });
    },
    changeCampaign() {
      this.selectedCampaign = this.campaignList.find(c => c.id === this.campaignID)
      this.isRefresh += 1
    },
    invokeTimelineUpdated() {
      this.isRefresh += 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?746c3064